import axios from 'axios';

import { BASE_HOST_URL } from '../config';

let baseURL = BASE_HOST_URL;
if (process.env.NODE_ENV === 'development') {
  baseURL = 'http://localhost:3005';
}

export function bookingEngineStatus() {
  return axios.get(`${BASE_HOST_URL}/api/v1/status/server`);
}

export function emailStatus() {
  return axios.get(`${BASE_HOST_URL}/api/v1/status/db`);
}



// WEBPACK FOOTER //
// ./src/services/status.js